import { addNotice } from '@api/announcement';
import { NoticeItemInterface } from '@api/announcement/type';
import ZeissButton from '@components/button';
import ZeissCollapse from '@components/collapse';
import { subjectMatterBrandKeyArr } from '@components/ProjectFromComponents/data';
import ZeissModal from '@components/zeiss-modal';
import { COMMON_PLACEHOLDER, ROLE_KEYS_MAP } from '@constants';
import { userInfo } from '@store';
import { SystemCityItemInterface } from '@store/systemCityStore';
import { dateFormat, getCityItem, getItemByKey } from '@utils/tool';
import {
  ANNOUNCEMENT_COLLAPSE_TYPE,
  DataFlagEnum,
  TARGET_STUFF,
  use_NOTICE_FORM_LIST
} from '@views/pages/AnnouncementList/announcement';
import { Col, CollapseProps, Form, FormListFieldData, Row, Space } from 'antd';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import {
  RenderFormDomInterface,
  rendercomponents
} from '../../../../utils/formRender';
import { sectorMap, sectorValueMap } from '../tool';
import './CreateAnnouncement.scss';

interface Props {
  open: boolean;
  setOpen: (val: boolean) => void;
  handleOk: (data?: any) => void;
  setSubjectMatterOpen: (val: boolean) => void;
  dicList: any;
  subjectMatterForm: any;
  systemCity: SystemCityItemInterface[];
}

export const initialFromValues = {
  tenderBudgetCurrency: '1',
  successfulPriceCurrency: '1'
};

export const initialSubjectMatterItemValues = {
  subjectMatterCurrency: '1',
  totalAmountCurrency: '1',
  subjectMatterNumber: 1
  // importType: '1'
};

// 直销
export const salesSectorArr = ['1', '2', '3'];
// 经销
export const dealerSectorArr = ['4', '5', '6'];

export const CreateAnnouncement = ({
  open,
  setOpen,
  setSubjectMatterOpen,
  dicList,
  systemCity,
  handleOk,
  subjectMatterForm
}: Props) => {
  const [form] = Form.useForm();
  const [userInfos] = useRecoilState(userInfo);
  const isSales = userInfos.roleKeys === ROLE_KEYS_MAP.sales;
  // const [subjectMatterForm] = Form.useForm(); // 标的物form
  const [isDealer, setIsDealer] = useState<boolean>(false);
  const {
    sector,
    noticeType: noticeTypeOptionsList,
    importType: importTypeOptionsList,
    currency,
    productLine,
    subjectMatterBrand: subjectMatterBrandList
  } = dicList;
  const sectorTypeFromForm: string = Form.useWatch('sectorType', form);
  const noticeTypeFromForm: string = Form.useWatch('noticeType', form);
  // 行业
  const industryKeyFromForm: string = Form.useWatch('industryKey', form);
  const subjectMatterNumberFromForm = Form.useWatch(
    'subjectMatter',
    subjectMatterForm
  );
  const NOTICE_FORM_LIST = use_NOTICE_FORM_LIST();

  const getFirstSector = () => {
    const sectorIds = userInfos.userTypesId || '';
    const firstSectorId = sectorIds.split(',')[0];

    return firstSectorId;
  };

  useEffect(() => {
    if (!subjectMatterNumberFromForm) {
      return;
    }
    const field = subjectMatterNumberFromForm.map(
      (v: {
        subjectMatterNumber: number;
        totalAmount: number;
        totalAmountCurrency: string;
      }) => {
        let subjectMatterPriceDefault = null;
        if (v.subjectMatterNumber && v.totalAmount && Number(v.totalAmount)) {
          subjectMatterPriceDefault = (
            v.totalAmount / v.subjectMatterNumber
          ).toFixed(2);
        }
        return {
          ...v,
          subjectMatterPrice: subjectMatterPriceDefault,
          subjectMatterCurrency: v.totalAmountCurrency
        };
      }
    );
    subjectMatterForm.setFieldsValue({
      subjectMatter: field
    });
    // // 台数
    // const { subjectMatterNumber } = subjectMatterNumberFromForm?.[0] ?? 0;
    // // 获取标的物中标总价单位重置标的物中标单价(万元)单位
    // const { totalAmountCurrency } = subjectMatterNumberFromForm?.[0] ?? '1';
    // const { totalAmount } = subjectMatterNumberFromForm?.[0] ?? 0;
    // let subjectMatterPriceDefault = null;
    // if (subjectMatterNumber && totalAmount) {
    //   subjectMatterPriceDefault = (totalAmount / subjectMatterNumber).toFixed(
    //     2
    //   );
    // }
    // subjectMatterForm.setFieldsValue({
    //   subjectMatter: [
    //     {
    //       ...subjectMatterNumberFromForm?.[0],
    //       subjectMatterPrice: subjectMatterPriceDefault,
    //       subjectMatterCurrency: totalAmountCurrency
    //     }
    //   ]
    // });
  }, [subjectMatterNumberFromForm]);

  useEffect(() => {
    if (!open) return;
    if (isSales) {
      form.setFieldsValue({
        sectorType: getFirstSector()
      });
    }
  }, [open]);

  useEffect(() => {
    form.setFieldsValue({
      customerCompanyType: '',
      industryKey: '',
      applicationDirectionKey: ''
    });
    setIsDealer(dealerSectorArr.includes(sectorTypeFromForm));
  }, [sectorTypeFromForm]);

  useEffect(() => {
    if (sectorTypeFromForm === sectorValueMap.AMS) {
      form.setFieldsValue({
        applicationDirectionKey: ''
      });
    }
  }, [industryKeyFromForm]);

  const addNoticeFn = async (data: NoticeItemInterface) => {
    const res = await addNotice(data);
    setOpen(false);
    form.resetFields();
    handleOk(res);
  };

  const addAnnouncementHandle = async () => {
    try {
      const values = await form.validateFields();
      const subjectMatterValues = await subjectMatterForm.validateFields();

      const {
        provinceAndCity,
        tenderBudgetCurrency,
        publishTime,
        tenderOpenTime,
        noticeType,
        customerCompanyType,
        industryKey,
        applicationDirectionKey,
        sectorType,
        successfulPriceCurrency,
        ...otherNoticeValues
      } = values;
      const tenderBudgetCurrencyItem = getItemByKey(
        currency,
        'dictKey',
        tenderBudgetCurrency
      );

      const provinceItem = getCityItem(provinceAndCity[0]);
      const cityCodeItem = getCityItem(provinceAndCity[1]);
      // 应用方向
      const applicationItem = getCityItem(
        applicationDirectionKey[0],
        COMMON_PLACEHOLDER
      );
      const applicationSecondItem = getCityItem(
        applicationDirectionKey[1],
        COMMON_PLACEHOLDER
      );
      // 客户单位类型
      const customerCompanyTypeItem = getCityItem(
        customerCompanyType[0],
        COMMON_PLACEHOLDER
      );
      const customerCompanyTypeSecondItem = getCityItem(
        customerCompanyType[1],
        COMMON_PLACEHOLDER
      );
      const sectorOptionsItem = getSectorRelatedOption();

      const params = {
        ...otherNoticeValues,
        dataFlag: isDealer ? DataFlagEnum.dealer : DataFlagEnum.directSelling,
        sectorType,
        sectorTypeValue: getItemByKey(sector, 'dictKey', sectorType)?.dictValue,
        industryKey,
        industryName: getItemByKey(
          sectorOptionsItem?.industry,
          'dictKey',
          industryKey
        )?.dictValue,
        noticeType,
        noticeTypeValue: getItemByKey(
          noticeTypeOptionsList,
          'dictKey',
          noticeType
        )?.dictValue,
        applicationDirectionKey: applicationItem?.code,
        applicationDirectionName: applicationItem?.label,
        applicationDirectionSecondKey: applicationSecondItem?.code,
        applicationDirectionSecondName: applicationSecondItem?.label,
        customerCompanyType: customerCompanyTypeItem?.code ?? 0,
        customerCompanyTypeName: customerCompanyTypeItem?.label ?? '',
        customerCompanySecondType: customerCompanyTypeSecondItem?.code ?? 0,
        customerCompanySecondTypeName:
          customerCompanyTypeSecondItem?.label ?? '',
        provinceCode: provinceItem?.code,
        provinceName: provinceItem?.label,
        cityCode: cityCodeItem?.code,
        cityName: cityCodeItem?.label,
        publishTime: dateFormat(publishTime),
        tenderOpenTime: dateFormat(tenderOpenTime),
        tenderBudgetCurrency,
        tenderBudgetCurrencyValue: tenderBudgetCurrency
          ? tenderBudgetCurrencyItem?.dictValue
          : null,
        successfulPriceCurrency,
        successfulPriceCurrencyValue: getItemByKey(
          currency,
          'dictKey',
          successfulPriceCurrency
        )?.dictValue
      };

      const subjectMatterParams = subjectMatterValues.subjectMatter.map(
        (v: any) => {
          const {
            productLineKey,
            importType,
            subjectMatterCurrency,
            estimatedPurchaseTime,
            totalAmountCurrency,
            subjectMatterBrandKey,
            subjectMatterBrand
          } = v;

          return {
            ...v,
            subjectMatterBrandKey,
            subjectMatterBrand:
              subjectMatterBrand ??
              getItemByKey(
                subjectMatterBrandList,
                'dictKey',
                subjectMatterBrandKey
              )?.dictValue,
            productLineName: getItemByKey(
              productLine,
              'dictKey',
              productLineKey
            )?.dictValue,
            importTypeValue: getItemByKey(
              importTypeOptionsList,
              'dictKey',
              importType
            )?.dictValue,
            subjectMatterCurrencyValue: getItemByKey(
              currency,
              'dictKey',
              subjectMatterCurrency
            )?.dictValue,
            totalAmountCurrencyValue: getItemByKey(
              currency,
              'dictKey',
              totalAmountCurrency
            )?.dictValue,
            estimatedPurchaseTime: dateFormat(estimatedPurchaseTime)
          };
        }
      );
      params.subjectMatter = subjectMatterParams;

      // 是否可以执行新建操作
      // const { successfulPrice, successfulPriceRemark } = params;

      // 选中标通知时候才需要校验中标金额和备注
      addNoticeFn(params);
      // if (
      //   noticeTypeFromForm !== '11' ||
      //   successfulPrice ||
      //   successfulPriceRemark
      // ) {
      //   addNoticeFn(params);
      // } else {
      //   message.error(subjectMatterErrorText);
      // }
    } catch (error) {
      console.log('error', error);
    }
  };

  const onFormChange = () => {};

  const getSectorRelatedOption = () => {
    const sectorDictItem = dicList.sectorDict?.[sectorMap[sectorTypeFromForm]];
    return sectorDictItem || {};
  };

  const renderSelectOptions = (data: any) => {
    const { name, optionsListKey } = data;
    let sectorOptionsItem = null;
    if (sectorTypeFromForm) {
      sectorOptionsItem = getSectorRelatedOption();
    }
    // Sector下拉联动
    if (name === 'customerCompanyType' && sectorTypeFromForm) {
      const { customerCompanyType } = sectorOptionsItem;
      return customerCompanyType;
    } else if (name === 'industryKey' && sectorTypeFromForm) {
      const { industry } = sectorOptionsItem;
      return industry;
    } else if (name === 'applicationDirectionKey' && sectorTypeFromForm) {
      const { applicationDirection, industry } = sectorOptionsItem;
      // AMS行业和应用方向联动逻辑
      if (sectorTypeFromForm === sectorValueMap.AMS) {
        const item = industry.find(
          (v: any) => v.dictKey === industryKeyFromForm
        );
        return item?.children || [];
      } else {
        return applicationDirection || [];
      }
    } else if (name === 'provinceAndCity') {
      return systemCity;
    }

    return dicList[optionsListKey] ?? [];
  };

  const renderForm = (data: any[] = [], isNotice: boolean = false) => {
    const obj: RenderFormDomInterface = {
      optionCallback: renderSelectOptions,
      // addonAfterCallback:getSuffixSelector,
      systemCity
    };
    return (
      <Form
        form={isNotice ? form : subjectMatterForm}
        layout="vertical"
        onValuesChange={onFormChange}
        initialValues={initialFromValues}
        preserve={false}
      >
        <Row gutter={[24, 0]} justify={'space-between'}>
          {data.map((item) => (
            <Col span={7} key={item.name}>
              <Form.Item
                label={item.label}
                name={item.name}
                rules={item.rules ? item.rules : [{ required: item.required }]}
              >
                {rendercomponents({
                  ...obj,
                  data: item,
                  dicList
                })}
              </Form.Item>
            </Col>
          ))}
        </Row>
      </Form>
    );
  };
  const formatRequiredArr = (arr: any[]) => {
    const mapArr = arr.map((item) => {
      if (item.name === 'totalAmount') {
        // return { ...item, required: noticeTypeFromForm === '11' };
      }
      return item;
    });
    return mapArr;
  };
  const CollapseItems: CollapseProps['items'] = [
    {
      key: ANNOUNCEMENT_COLLAPSE_TYPE.NOTICE,
      label: '公告信息',
      children: renderForm(formatRequiredArr(NOTICE_FORM_LIST), true)
    }
  ];

  const onCollapseItemDelete = (data: any) => {
    const index = data.panelKey.replace(
      ANNOUNCEMENT_COLLAPSE_TYPE.TARGET_STUFF + '_',
      ''
    );
    const oldData = subjectMatterForm.getFieldsValue();
    let newData = _.cloneDeep(oldData.subjectMatter);
    newData.splice(index, 1);
    subjectMatterForm.setFieldsValue({
      subjectMatter: newData
    });
  };

  // 标的物删除按钮，第一个没有，其他的都有删除按钮
  const renderExpandIconCallback = (
    props: any,
    collapseItemKey: string | number = ''
  ) => {
    const { panelKey } = props;
    if (panelKey === collapseItemKey) {
      return;
    } else {
      return (
        <ZeissButton
          type="link"
          danger
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onCollapseItemDelete(props);
          }}
        >
          删除
        </ZeissButton>
      );
    }
  };

  // 兼容客户需求Radio点击能取消。。。
  const formClick = (e: any) => {
    e.stopPropagation();
    e.preventDefault();

    const { importType } = subjectMatterNumberFromForm?.[0] ?? 0;

    if (e.target.value === importType) {
      subjectMatterForm.setFieldsValue({
        subjectMatter: [
          {
            ...subjectMatterNumberFromForm?.[0],
            importType: ''
          }
        ]
      });
    }
  };

  const formatsubjectMatteArr = (arr: any[]) => {
    const { subjectMatterBrandKey } = subjectMatterNumberFromForm?.[0] ?? 0;
    const mapArr = arr
      .filter((item) => {
        if (
          item.name === 'subjectMatterBrand' &&
          !subjectMatterBrandKeyArr.find((v) => v === subjectMatterBrandKey)
        ) {
          return false;
        }
        return true;
      })
      .map((item) => {
        if (item.name === 'importType') {
          item.onClick = formClick;
        }
        if (item.name === 'totalAmount') {
          // item.required = noticeTypeFromForm === '11';
        }
        return {
          ...item
        };
      });

    return mapArr;
  };

  const formListRender = (
    fields: FormListFieldData[]
    // operation: FormListOperation
  ) => {
    // const { add, remove, move } = operation;
    const CollapseSubjectMatterArr: CollapseProps['items'] = [];
    const obj: RenderFormDomInterface = {
      optionCallback: renderSelectOptions,
      // addonAfterCallback:getSuffixSelector,
      systemCity
    };

    const curFromData = subjectMatterForm.getFieldsValue();
    fields.map((field, index) => {
      const { name } = field;
      CollapseSubjectMatterArr.push({
        key: ANNOUNCEMENT_COLLAPSE_TYPE.TARGET_STUFF + '_' + index,
        label:
          index === 0 ? (
            '标的物'
          ) : (
            <>
              <span className="collapse-pane">新增标的物</span>
              {curFromData.subjectMatter[index]?.subjectMatterName}
            </>
          ),
        children: (
          <Row gutter={[24, 0]} justify={'space-between'}>
            {formatsubjectMatteArr(TARGET_STUFF).map((item) => (
              <Col span={7} key={item.name}>
                <Form.Item
                  label={item.label}
                  name={[name, item.name]}
                  rules={[{ required: item.required }]}
                >
                  {rendercomponents({ ...obj, data: item, dicList }, field)}
                </Form.Item>
              </Col>
            ))}
          </Row>
        )
      });
      return fields;
    });

    return (
      <ZeissCollapse
        items={CollapseSubjectMatterArr}
        defaultActiveKey={[CollapseSubjectMatterArr[0]?.key ?? '']}
        accordion
        renderExpandIcon={(data) =>
          renderExpandIconCallback(data, CollapseSubjectMatterArr[0].key || '')
        }
      />
    );
  };

  const renderSubjectMatterCollapse = () => {
    return (
      <Form
        form={subjectMatterForm}
        layout="vertical"
        onValuesChange={onFormChange}
        preserve={false}
        initialValues={{
          subjectMatter: [initialSubjectMatterItemValues]
        }}
      >
        <Form.List name="subjectMatter">{formListRender}</Form.List>
      </Form>
    );
  };

  const onModalCancel = () => {
    setOpen(false);
    form.resetFields();
  };

  return (
    <ZeissModal
      open={open}
      width={1100}
      centered
      footer={null}
      onCancel={onModalCancel}
      destroyOnClose
      className="pc-createAnnouncement-Modal"
    >
      <div className="pc-createAnnouncementLayout1">
        <div className="pc-createAnnouncement-title">
          新建公告
          {isDealer ? (
            <span className="pc-createAnnouncement-tit-dealer">经销</span>
          ) : (
            <span className="pc-createAnnouncement-tit-sales">直销</span>
          )}
        </div>
        <div className="pc-createAnnouncement-content">
          <ZeissCollapse
            items={CollapseItems}
            defaultActiveKey={[ANNOUNCEMENT_COLLAPSE_TYPE.NOTICE]}
            accordion
          ></ZeissCollapse>
          {renderSubjectMatterCollapse()}
        </div>
        <Space className="pc-createAnn-footer" size="middle">
          <ZeissButton
            className="pc-createAnn-add"
            onClick={() => setSubjectMatterOpen(true)}
          >
            添加标的物
          </ZeissButton>
          <ZeissButton className="pc-createAnn-cancel" onClick={onModalCancel}>
            取消
          </ZeissButton>
          <ZeissButton
            type="primary"
            className="pc-createAnn-sales"
            onClick={addAnnouncementHandle}
          >
            确认新建
          </ZeissButton>
        </Space>
      </div>
    </ZeissModal>
  );
};
